import React, { FC, ReactNode, useMemo } from 'react';

import { BaseStyleEnums, CustomIcons } from '@nhl/nhl-breakaway-ui';

import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';
import { Wiper } from '~/views/components/wiper/Wiper';

import { CarouselRow, LinksRow, RoundRow } from '../../styles';
import { DraftPickContainer } from '../draftPickSlide/styles';
import { HeaderWrapper, MediumGapContainer } from '../header/styles';

import { SkeletonWrapper } from './styles';

const Skeleton: FC = () => {
    const screenSize = useSizeWithThrottle();

    const isSmallerThanMediumScreen = useMemo<boolean>(
        () => screenSize.width < BaseStyleEnums.ScreenWidthBreakpoints.medium,
        [screenSize]
    );

    const picks: Array<ReactNode> = [];

    for (let i = 0; i < (isSmallerThanMediumScreen ? 4 : 8); i++) {
        picks.push(
            <DraftPickContainer key={i}>
                <Wiper />
                <CustomIcons.EmptyShield />
            </DraftPickContainer>
        );
    }

    return (
        <SkeletonWrapper>
            <HeaderWrapper>
                <CustomIcons.EmptyShield />
                <MediumGapContainer $expand>
                    <Wiper />
                </MediumGapContainer>
                {!isSmallerThanMediumScreen && (
                    <MediumGapContainer $expand>
                        <Wiper />
                    </MediumGapContainer>
                )}
            </HeaderWrapper>
            <RoundRow>
                <MediumGapContainer>
                    <Wiper />
                </MediumGapContainer>
            </RoundRow>
            <CarouselRow>{picks}</CarouselRow>
            {isSmallerThanMediumScreen && (
                <LinksRow>
                    <MediumGapContainer $expand>
                        <Wiper />
                    </MediumGapContainer>
                    <MediumGapContainer $expand>
                        <Wiper />
                    </MediumGapContainer>
                </LinksRow>
            )}
        </SkeletonWrapper>
    );
};

export default Skeleton;
